<p-tag [value]="value()" [severity]="$adaptedSeverity()" [rounded]="rounded()" [styleClass]="styleClass()">
  @if (icon(); as iconClass) {
    <ng-template pTemplate="icon">
      <i [class]="iconClass"></i>
    </ng-template>
  }
  <ng-content></ng-content>
</p-tag>
